import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putLocation } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.PUT,
  api: putLocation,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/locations/PutAction.js